import React, { Component } from 'react'
import axios from 'axios'
import ls from 'local-storage'
import TabNav from './../TabNav';
import Tab from './../Tab';
import Beneficiary from './Beneficiary';
import Siteinformation from './Siteinformation';
import Tscboard from './Tscboard';
import Administrativeapproval from './Administrativeapproval';
import Technicalsanction from './Technicalsanction';
import Dtp from './Dtp';
import Invitingtenders from './Invitingtenders';
import Tenderapproval from './Tenderapproval';
import Leveldetails from './Leveldetails';
import Workoder from './Workoder';
import Scheduleb from './Scheduleb';
import Expenditure from './Expenditure';
import Progress from './Progress';
import Synopsisofproject from './Synopsisofproject';
import Deductionholdamount from './Deductionholdamount';
import Timelimit from './Timelimit';
import Extraitem from './Extraitem';
import BgFdr from './BgFdr';
import UTCCertificate from './UTCCertificate';
import ExcessSaving from './ExcessSaving';

export class Partworkdetails extends Component {
    constructor(props){      
        super(props);   
        this.state = {
          selected: 'Work',
          tablist:[],
          detaills:[],
        }  
      }  
      componentDidMount() {
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken; 
        Axios.get(`${process.env.REACT_APP_API_URL}master/getpartworktab/`)
        .then(result=>{
          if(result.status === 200){
            this.setState({tablist:result.data});                      
          }      
        });    
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/partworkdata/workhead/`+ this.props.match.params.workhead + `/partworkhead/` + this.props.match.params.partworkhead + `/officecode/` + this.props.match.params.officecode)
        .then(result=>{
          if(result.status === 200){
            this.setState({detaills:result.data});                      
          }      
        });                 
    }          
      setSelected = (tab) => {
        this.setState({ selected: tab });
      }     
    render() {
        return (
            <div className="content-wrapper">
            <section className="content-header">
              <h1>
              Partwork Details
              </h1>
              <ol className="breadcrumb">
              <li><i className="fa fa-dashboard"></i> Home</li>
              <li className="active">Partwork Details</li>
              </ol>
            </section>
            <section className="content">
            
		<div className="box">
		<div className="box-body"> 
    <div className="col-md-12">
<strong> 
<span className="text-danger">{this.state.detaills.workhead + '/' + this.state.detaills.partworkhead } </span> 
: { this.state.detaills.workname + '  ' + this.state.detaills.worknameguj } <br></br>
<span className="text-success"> { this.state.detaills.partworkname + '  ' + this.state.detaills.partworknameguj } </span> <br></br>
Demand No: <span className="text-danger">{ this.state.detaills.demandno }</span> 
Major: <span className="text-danger"> { this.state.detaills.majhead } </span> 
SubMajor: <span className="text-danger"> { this.state.detaills.submajhead } </span> 
Minor: <span className="text-danger">{this.state.detaills.minhead } </span> 
Sub: <span className="text-danger">{this.state.detaills.subhead}</span> 
Details: <span className="text-danger">{this.state.detaills.detailshead}</span> 
Objhead: <span className="text-danger">{this.state.detaills.objhead}</span> 
Subobjhead: <span className="text-danger">{this.state.detaills.subobjhead}</span>
</strong>
</div>  
</div>  
	  <div className="callout callout-info">
<h4>Edit and Delete Rights of A.A. has been assigned to C.E. and S.E. Level Users || Edit and Delete Rights of TS, DTP, Inviting Tender, Tender Approval, Work Order, Progress, Time Limit ,Excess / Extra has been assigned to EE Level Users</h4>
</div>
</div>               
            <TabNav tabs={this.state.tablist} selected={ this.state.selected } setSelected={ this.setSelected }>
              <Tab isSelected={ this.state.selected === 'Work' }>
                        <Beneficiary>{this.props.match.params}</Beneficiary>
              </Tab>
              <Tab isSelected={ this.state.selected === 'Site Information' }>
                          <Siteinformation>{this.props.match.params}</Siteinformation>
              </Tab>
              <Tab isSelected={ this.state.selected === 'TSC/Board' }>
                          <Tscboard>{this.props.match.params}</Tscboard>
              </Tab>
              <Tab isSelected={ this.state.selected === 'Administration Approval' }>
                          <Administrativeapproval>{this.props.match.params}</Administrativeapproval>
              </Tab> 
              <Tab isSelected={ this.state.selected === 'Technical Sanction' }>
                          <Technicalsanction>{this.props.match.params}</Technicalsanction>
              </Tab>              
              <Tab isSelected={ this.state.selected === 'DTP' }>
                          <Dtp>{this.props.match.params}</Dtp>
              </Tab>
              <Tab isSelected={ this.state.selected === 'Inviting Tenders' }>
                          <Invitingtenders>{this.props.match.params}</Invitingtenders>
              </Tab> 
              <Tab isSelected={ this.state.selected === 'Tender Approval' }>
                          <Tenderapproval>{this.props.match.params}</Tenderapproval>
              </Tab>
              <Tab isSelected={ this.state.selected === 'L2/L3/L4' }>
                          <Leveldetails>{this.props.match.params}</Leveldetails>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Work Order' }>
                          <Workoder>{this.props.match.params}</Workoder>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'BG/FDR' }>
                          <BgFdr>{this.props.match.params}</BgFdr>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Schedule-B' }>
                          <Scheduleb>{this.props.match.params}</Scheduleb>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Progress' }>
                          <Progress>{this.props.match.params}</Progress>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Synopsis of Project' }>
                          <Synopsisofproject>{this.props.match.params}</Synopsisofproject>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Expenditure' }>
                          <Expenditure>{this.props.match.params}</Expenditure>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Deduction/Hold Amount' }>
                          <Deductionholdamount>{this.props.match.params}</Deductionholdamount>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Time Limit' }>
                          <Timelimit>{this.props.match.params}</Timelimit>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Extra' }>
                          <Extraitem>{this.props.match.params}</Extraitem>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'UTC Certificate/Form 3A' }>
                          <UTCCertificate>{this.props.match.params}</UTCCertificate>
              </Tab>                             
              <Tab isSelected={ this.state.selected === 'Excess/Saving' }>
                          <ExcessSaving>{this.props.match.params}</ExcessSaving>
              </Tab>                           
            </TabNav>   
          </section>
          </div>
        )
    }
}

export default Partworkdetails
